/**
 * Map raw SPA paths to short human-readable titles (analyzer app conventions).
 */
export function humanizeAnalyticsPath(rawPath: string): {
  label: string;
  detail?: string;
} {
  const path = (rawPath ?? '').split('?')[0]?.trim() || '';
  if (path === '' || path === '/') {
    return { label: 'Home' };
  }

  const withQuery = rawPath ?? '';

  if (/^\/suite-details\//i.test(path)) {
    const from = matchQueryParam(withQuery, 'from');
    const suffix = from ? ` (from ${from.replace(/-/g, ' ')})` : '';
    return { label: `Suite Details${suffix}` };
  }
  if (/^\/treo-suite-details\//i.test(path)) {
    return { label: 'Treo Suite Details' };
  }
  if (path === '/analysis' || path.startsWith('/analysis/')) {
    return { label: 'Analysis' };
  }
  if (path === '/ai-conversation' || path.startsWith('/ai-conversation/')) {
    return { label: 'AI Conversation' };
  }
  if (path === '/search-results' || path.startsWith('/search-results')) {
    return { label: 'Search Results' };
  }
  if (path === '/dashboard' || path.startsWith('/dashboard')) {
    return { label: 'Dashboard' };
  }

  const seg = path.replace(/^\//, '').split('/')[0];
  if (seg) {
    return {
      label: seg
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' '),
    };
  }
  return { label: path || 'Unknown' };
}

function matchQueryParam(qs: string, key: string): string | null {
  try {
    const i = qs.indexOf('?');
    if (i < 0) {
      return null;
    }
    const params = new URLSearchParams(qs.slice(i + 1));
    return params.get(key);
  } catch {
    return null;
  }
}

/** Truncate middle of long path for display; keep start and end. */
export function truncatePathMiddle(s: string, maxLen: number): string {
  if (!s || s.length <= maxLen) {
    return s;
  }
  const keep = maxLen - 3;
  const head = Math.ceil(keep / 2);
  const tail = Math.floor(keep / 2);
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
}
